var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svgicon',{class:['icon', _vm.iconCustomClass],style:(_vm.style),attrs:{"name":_vm.name,"width":_vm.width ? _vm.width : _vm.size,"height":_vm.height ? _vm.height : _vm.size,"dir":_vm.dir},nativeOn:{"mouseover":function($event){_vm.isHovered = true},"mouseleave":function($event){_vm.isHovered = false}}})
}
var staticRenderFns = []

export { render, staticRenderFns }